import React, { useEffect, useState } from "react";
import styles from "./GeneralInformation.module.css";
import Header from "../../Header/Header";
// import ProgressBar from "./ProgressBar";
import { useNavigate } from "react-router-dom";
import config from "../../../config";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import PhoneInputField from "../../../components/PhoneInput/PhoneInput";
import { useProfile } from "../../../contexts/ProfileContext";
import { showErrorToast, validateUSPhoneNumber } from "../../utils";
import ProgressBar from "../../../components/ProgressBar";
const GeneralInfoHomeInspection = () => {
    const navigate = useNavigate();
    const { profileData: profile } = useProfile();

    // State variables to capture form input
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("");
    const [email, setEmail] = useState("");
    const [address, setAddress] = useState("");
    const [unitNumber, setUnitNumber] = useState("");
    const storageInfo = JSON.parse(sessionStorage.getItem("inspectionInfo"));
    useEffect(() => {
        if (storageInfo?.generalInfo) {
            const generalInfo = storageInfo.generalInfo;
            setFirstName(generalInfo.firstName);
            setLastName(generalInfo.lastName);

            // Ensure phone number is properly formatted for US
            if (generalInfo.phoneNumber) {
                const digitsOnly = generalInfo.phoneNumber.replace(/\D/g, "");
                if (digitsOnly.length === 10) {
                    setPhoneNumber("1" + digitsOnly);
                } else if (digitsOnly.length === 11 && digitsOnly.startsWith("1")) {
                    setPhoneNumber(digitsOnly);
                } else {
                    setPhoneNumber(generalInfo.phoneNumber);
                }
            } else {
                setPhoneNumber("1");
            }

            setEmail(generalInfo.email);
        }
    }, []);

    useEffect(() => {
        setFirstName(profile?.first_name);
        setLastName(profile?.last_name);

        // Ensure phone number is properly formatted for US
        if (profile?.phone) {
            const digitsOnly = profile.phone.replace(/\D/g, "");
            if (digitsOnly.length === 10) {
                // Add US country code if it's a 10-digit number
                setPhoneNumber("1" + digitsOnly);
            } else if (digitsOnly.length === 11 && digitsOnly.startsWith("1")) {
                // Already has US country code
                setPhoneNumber(digitsOnly);
            } else {
                setPhoneNumber(profile.phone);
            }
        } else {
            setPhoneNumber("1");
        }

        setEmail(profile?.email);
    }, [profile]);

    const handleSubmit = async (e) => {
        e.preventDefault(); // Prevent the default form submission behavior

        // Validate form inputs
        if (!validateForm()) return;

        const authUserToken = localStorage.getItem("authUser");
        const authUser = authUserToken ? authUserToken.replace(/^"|"$/g, "") : "";

        try {
            sessionStorage.setItem("inspectionInfo", JSON.stringify({ ...storageInfo, generalInfo: { firstName, lastName, phoneNumber, email } }));
            navigate("/services/inspection-property-info", { state: { firstName, lastName, phoneNumber, email } });

            // const response = await fetch(`${config.get("API_URL")}/api/personal_info`, {
            //     method: "POST",
            //     headers: {
            //         "Content-Type": "application/json",
            //         Authorization: `Bearer ${authUser}`,
            //     },
            //     body: JSON.stringify({
            //         first_name: firstName,
            //         last_name: lastName,
            //         email: email,
            //         phone_number: phoneNumber,
            //         address: address,
            //         unit_number: unitNumber,
            //     }),
            // });

            // const responseData = await response.json(); // Parse the response body

            // if (response.ok) {
            //     showSuccessToast("Form submitted successfully!");
            //     navigate("/services/insurance-quote/step-2");
            // } else {
            //     console.log("Error Response:", responseData); // Log the error response
            //     showErrorToast(`Failed to submit: ${responseData.message || "Please try again."}`);
            // }
        } catch (error) {
            console.error("Error submitting the form:", error);
            showErrorToast("An error occurred. Please try again.");
        }
    };

    useEffect(() => {
        document.title = `Insurance Services | ${config.get("COMPANY_NAME")}`;
    }, []);

    const validateForm = () => {
        if (!firstName || !lastName || !phoneNumber || !email) {
            showErrorToast("Please fill in all fields.");
            return false;
        }
        if (!validateUSPhoneNumber(phoneNumber)) {
            showErrorToast("Please enter a valid US phone number.");
            return false;
        }
        // Email validation
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
            showErrorToast("Please enter a valid email address.");
            return false;
        }

        return true; // If everything is valid
    };

    return (
        <div className={`${styles.container} tw-bg-background_color`}>
            <main className={`${styles.mainContent} tw-overflow-auto`}>
                <Header title="Home Inspection" />
                <section className={`${styles.formSection} tw-py-0`}>
                    <ProgressBar currentStep={1} totalSteps={3} />
                    <div className={`${styles.formContainer} tw-mt-10`}>
                        <h1 className={styles.formTitle}>General Information</h1>
                        {/* <p className="tw-font-semibold">Help us connect you with the perfect insurance partner.</p> */}
                        <p className={styles.formDescription}>
                            Before scheduling your home inspection, please provide some basic details about your property. This helps us tailor the
                            inspection to your needs. Your information is secure and will only be used for this purpose.
                        </p>
                        <form className={styles.generalForm} onSubmit={handleSubmit}>
                            <div className={styles.formRow}>
                                <div className={styles.fieldContainer}>
                                    <label className={styles.fieldLabel}>First Name</label>
                                    <input
                                        type="text"
                                        className={styles.fieldInput}
                                        placeholder="Enter your First name"
                                        value={firstName}
                                        required={true}
                                        onChange={(e) => setFirstName(e.target.value)}
                                    />
                                </div>
                                <div className={styles.fieldContainer}>
                                    <label className={styles.fieldLabel}>Last Name</label>
                                    <input
                                        type="text"
                                        className={styles.fieldInput}
                                        placeholder="Enter your Last name"
                                        value={lastName}
                                        required={true}
                                        onChange={(e) => setLastName(e.target.value)}
                                    />
                                </div>
                            </div>
                            <div className={styles.formRow}>
                                <div className={styles.fieldContainer}>
                                    <label className={styles.fieldLabel}>Phone Number</label>
                                    <PhoneInputField
                                        phone={phoneNumber}
                                        setPhone={(val) => {
                                            console.log(">>>>>>>input number", val);
                                            setPhoneNumber(`+${val}`);
                                        }}
                                    />
                                    {/* <input
                                        type="text"
                                        className={styles.fieldInput}
                                        placeholder="Enter your phone number"
                                        value={phoneNumber}
                                        required={true}
                                        onChange={(e) => setPhoneNumber(e.target.value)}
                                    /> */}
                                </div>
                                <div className={styles.fieldContainer}>
                                    <label className={styles.fieldLabel}>Email Address</label>
                                    <input
                                        type="email"
                                        className={styles.fieldInput}
                                        placeholder="Enter your Email Address"
                                        value={email}
                                        required={true}
                                        onChange={(e) => setEmail(e.target.value)}
                                    />
                                </div>
                            </div>
                            <p className="tw-text-secondary tw-italic">
                                Your privacy is our priority. We’ll never share your information without your explicit consent{" "}
                            </p>
                            <div className="tw-flex tw-justify-center tw-w-full">
                                <button type="submit" className={`${styles.submitButton} tw-bg-primary hover:tw-bg-primary_hover tw-w-fit`}>
                                    Next: Property Details
                                </button>
                            </div>
                        </form>
                    </div>
                </section>
            </main>
        </div>
    );
};

export default GeneralInfoHomeInspection;
